<template>
  <div class="machines-show-matrix container-fluid">
    <h2 class="page-heading">Матрица {{matrix | get('name')}}</h2>

    <transition name="fade">
      <div class="row">
        <div class="col-md-4" v-if="matrix">
          <div class="card mb-4">
            <h3 class="card-header"><span class="text-caps">Матрица</span></h3>
            <div class="card-body">
              <table class="table-sm m-0 px-0">
                <thead>
                <tr>
                  <th style="width: 3em;" class="text-right">№</th>
                  <th>Продукт</th>
                  <!--<th>Цена</th>-->
                </tr>
                </thead>
                <tr v-for="(product, index) in matrix.products" v-if="product.product_id">
                  <td class="text-right">{{matrix | get(`product_numbers[${index}]`, index+1)}}</td>
                  <td v-if="product.product">
                    <router-link
                      :to="`/settings/recipes/products/${product.product_id}`"
                      class="text-dark"
                    >{{product.product.name}}</router-link>
                  </td>
                  <td v-else>
                    <small><samp
                      class="text-muted"
                      data-title="Некорректная ссылка"
                      data-toggle="tooltip"
                      data-placement="right"
                    >
                      {{product.product_id}}
                    </samp></small>
                  </td>
                  <!--<td>{{product.cost}} Р.</td>-->
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="col-md">
          <div class="card mb-4">
            <h3 class="card-header"><span class="text-caps">Остатки ингредиентов</span></h3>
            <div class="card-body">
              <table class="table-sm m-0 px-0 w-100">
                <thead>
                <tr>
                  <th>Ингредиент</th>
                  <th class="text-right">Остаток</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="ingredient in machine.critical_remainders">
                  <td :class="{'text-danger': ingredient.remainder < 0.01}">{{ ingredient.component.name }}</td>
                  <td>
                    <div class="media align-items-center justify-content-end">
                      <small>{{ingredient.remainder | remainder}} / {{ingredient.full}} {{ingredient.component.measure}}</small>
                      <progress-bar
                        :value="ingredient.remainder | remainder"
                        :max="parseInt(ingredient.full)"
                        :threshold="ingredient.critical"
                        :state="ingredient.remainder > ingredient.critical ? 'success' : 'danger'"
                        class="ml-3"
                        style="min-width: 100px; width: 10vw;"
                      />
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import find from 'lodash/find'
  import map from 'lodash/map'
  import api from '@/api'

  export default {
    props: {
      id: {required: true},
      machine: {type: Object},
    },
    data () {
      return {}
    },
    computed: {
      matrix () {
        return this.machine.matrix
      },
    },
  }
</script>

<style lang="scss">
  @import "boot";

  .machines-show-matrix {
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/machines/_id/matrix.vue